import {
  ActionContext,
  ActionDescriptor,
  ActionDescriptorPromptAuthAction,
  ActionDescriptorOpenBranchLinkAction,
} from '../../../controllers/VideoOverlayPresentation';
import viddsee from '@/scripts/viddsee';
import { createLinkSync } from '@/scripts/Components/Utilities/BranchLinkButton/branch-link/creator';
import { accumulateSectionUi } from '@/scripts/libs/analytic/section-ui-accumulator';

const makeLoginFunction = (action: ActionDescriptorPromptAuthAction, actionContext: ActionContext): void => {
  viddsee.ui.modal.register.open({
    ...action.data,
    authTrackerPayload: {
      ...action.data?.authTrackerPayload,
      section: action.data?.authTrackerPayload?.section ?? (actionContext.el ? accumulateSectionUi(actionContext.el) : null),
    },
  });
};
const makeBranchLinkFunction = (action: ActionDescriptorOpenBranchLinkAction): void => {
  // @TODO: [TODO 16] Implement this
  if (action.data == null) {
    throw new Error('Cannot create branch button as Branch data is not provided.');
  }

  const link = createLinkSync(action.data);
  window.open(link, '_blank', 'noopener');
};

export const getAction = (action: ActionDescriptor['action'], actionContext: ActionContext): (() => any) | null => {
  switch (action.type) {
    case 'promptAuth': return (): void => makeLoginFunction(action, actionContext);
    case 'openBranchLink': return (): void => makeBranchLinkFunction(action);
    default:
      return null;
  }
};
